import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { QueryClient } from "@tanstack/react-query";

type QueryProviderProps = {
    queryClient: QueryClient;
    children: React.ReactNode;
};

const QueryProvider = ({ queryClient, children }: QueryProviderProps) => (
    <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
);

export default QueryProvider;
